export interface NetworkAttributes {
  connectionType?: string;
  effectiveType?: string;
  saveData?: boolean;
}

interface NetworkInformationLike {
  type?: string;
  effectiveType?: string;
  saveData?: boolean;
}

/**
 * Reads connection metadata via the Network Information API.
 *
 * Not available in all browsers (notably Safari). When unsupported each
 * unavailable attribute is **omitted** from the returned object so the caller
 * can spread it into a payload without sending `null`s to NewRelic.
 */
export const getNetworkAttributes = (): NetworkAttributes => {
  if (typeof navigator === "undefined") {
    return {};
  }

  const connection = (navigator as Navigator & { connection?: NetworkInformationLike }).connection;
  if (!connection) {
    return {};
  }

  const attributes: NetworkAttributes = {};
  if (connection.type !== undefined) {
    attributes.connectionType = connection.type;
  }
  if (connection.effectiveType !== undefined) {
    attributes.effectiveType = connection.effectiveType;
  }
  if (connection.saveData !== undefined) {
    attributes.saveData = connection.saveData;
  }
  return attributes;
};
